module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/black-logo-17443aef3ec0b84140fa29a786efbdd6.png";